import firestoreServices from 'src/services/firestore.service';
import rolesServices from 'src/services/roles.services';

const usersFirestoreServices = firestoreServices('users');

const getSubcollection = async doc => {
  let data = doc.data();

  for (let key in data) {
    const item = data[key];
    if (typeof item === 'object' && item && item.parent) {
      await firestoreServices(item.parent.id).get(item.id, async itemData => {
        data[key] = itemData;
      });
    }
  }

  return { id: doc.id, ...data };
};

const listElements = queryResult => {
  const elements = queryResult.docs.map(async (doc, _) => {
    return await getSubcollection(doc);
  });

  return Promise.all(elements);
};

export default {
  ...usersFirestoreServices,
  add: (data, onSuccess, onError = _ => {}) => {
    if (typeof data.rol === 'string' || data.rol instanceof String) {
      data.rolId = data.rol
      data.rol = rolesServices.docRef(data.rol);
    }
    return usersFirestoreServices.add(
      { ...data, isActive: true },
      onSuccess,
      onError
    );
  },
  update: (id, data, onSuccess, onError = _ => {}) => {
    if (typeof data.rol === 'string' || data.rol instanceof String) {
      data.rolId = data.rol
      data.rol = rolesServices.docRef(data.rol);
    }
    return usersFirestoreServices.update(id, data, onSuccess, onError);
  },
  all: (onResult, onError = _ => {}) =>
    usersFirestoreServices
      .collectionRef()
      .get()
      .then(async queryResult => onResult(await listElements(queryResult)))
      .catch(onError),
  active: (id, onSuccess = _ => {}, onError = _ => {}) =>
    usersFirestoreServices.update(id, { isActive: true }, onSuccess, onError),
  close: (id, onSuccess = _ => {}, onError = _ => {}) =>
    usersFirestoreServices.update(id, { isActive: false }, onSuccess, onError),
  whereSpecialty: (specialtyId, onSuccess = _ => {}, onError = _ => {}) =>{
    firestoreServices('users')
      .collectionRef()
      .where('specialties', 'array-contains', specialtyId)
      .where('isActive', '==', true)
      .get()
      .then(async queryResult => onSuccess(await listElements(queryResult)));
  }
};
